const BUSINESS_VALIDATION_STATUSES = {
  BN_VERIFIED: 'bn_verified',
  BN_VERIFIED_NO_GST: 'bn_verified_no_gst',
  BN_VERIFIED_GST_UNKNOWN: 'bn_verified_gst_unknown',
  BN_CANCELLED: 'bn_cancelled',
  BN_INVALID: 'bn_invalid',
  NOT_VALIDATED: 'not_validated',
} as const;

export default BUSINESS_VALIDATION_STATUSES;
